import { customAlphabet } from 'nanoid';

const alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';

function generateTinyNanoId(forbiddenChars = ''): string {
  const allowedAlphabet = alphabet
    .split('')
    .filter((char) => !forbiddenChars.includes(char))
    .join('');

  if (!allowedAlphabet) {
    throw new Error(
      'generateTinyNanoId: empty alphabet after applying forbiddenChars'
    );
  }

  const tinyNanoId = customAlphabet(allowedAlphabet, 8);

  let newNanoId: string;

  do {
    newNanoId = tinyNanoId();
  } while (!/[A-Z]/.test(newNanoId));

  return newNanoId;
}

export default generateTinyNanoId;
